import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';

class BQXConfiguration {
    static set setConfig(value) {
        BQXConfiguration.data = value;
    }
}

class BqxUiCommonModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: BqxUiCommonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.8", ngImport: i0, type: BqxUiCommonModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: BqxUiCommonModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.8", ngImport: i0, type: BqxUiCommonModule, decorators: [{
            type: NgModule,
            args: [{}]
        }] });

/*
 * Public API Surface of bqx-ui-common
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BQXConfiguration, BqxUiCommonModule };
